import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ContactUsRequest } from "../../../Models";

interface ContactUsState {
    contactUsIsLoading: boolean;
    contactUsErrorMessage: string | undefined;

    contactUsFormData: ContactUsRequest;
}

const initialContactState: ContactUsState = {
    contactUsIsLoading: false,
    contactUsErrorMessage: "",

    contactUsFormData: {
        fullName: "",
        country: "",
        region: undefined,
        mobilePhone: "",
        email: "",
        expertise: "",
        description: "",
        url: "",
        mainInterest: "",
    },
};

export const contactUsSlice = createSlice({
    name: "contactUs",
    initialState: initialContactState,
    reducers: {
        setContactUsProgress: (state: ContactUsState) => {
            state.contactUsIsLoading = true;
            state.contactUsErrorMessage = undefined;
        },
        setContactUsFailed: (state: ContactUsState, action: PayloadAction<string>) => {
            state.contactUsIsLoading = false;
            state.contactUsErrorMessage = action.payload;
        },
        setContactUsCompleted: (state: ContactUsState) => {
            state.contactUsIsLoading = false;
            state.contactUsErrorMessage = undefined;
        },

        setContactUsFormData: (state: ContactUsState, action: PayloadAction<ContactUsRequest>) => {
            state.contactUsFormData = action.payload;
        },
    },
});

export const Reducer = contactUsSlice.reducer;
export const Actions = contactUsSlice.actions;
